import React, { useState } from 'react';
import PropTypes from 'prop-types';

const ToggleLabel = props => {
  const [check, setCheck] = useState(props.check);

  let rbSwitcherToggleClass = 'rb-switcher blue'
  if (check) {
    rbSwitcherToggleClass = `${rbSwitcherToggleClass} checked`;
  }
  return (
    <div className="toggleLabel">
      <span className="toggleHeading">Full {props.label} Name</span>
      <span className="radio-toggle">
        <label className={rbSwitcherToggleClass} htmlFor={props.label}>
          <input
            type="radio"
            name="toggleLabel"
            id={props.label}
            checked={check}
            onClick={() => {
              setCheck(!check);
              props.setToggleLabelFlag(props.label.toLowerCase(), !check ? 'FULL' : 'SHORT');
            }
            }
          />{' '}
          <i />
        </label>
      </span>
    </div>
  );
};

ToggleLabel.propTypes = {
  label: PropTypes.string,
  check: PropTypes.bool,
  setToggleLabelFlag: PropTypes.func,
};

export default ToggleLabel;
